<angular-editor
  [config]="editorConfig"
  [(ngModel)]="editorContent"
  (ngModelChange)="editorData($event)"
  (blur)="onBlur($event)"
></angular-editor>
<!-- <button (click)="editorData($event)">Submit</button> -->
